var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-template"},[_vm._v("列表模板 "),_c('ul',_vm._l((_vm.templateConfig),function(value,key){return _c('li',{key:key},[_vm._v(" "+_vm._s(value)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }